module.exports = __webpack_public_path__ + "img/banner-2.f55089cc.jpg";